<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2233_44787)">
<path d="M3 5.40012C3 4.26875 3 3.70307 3.35147 3.35159C3.70294 3.00012 4.26863 3.00012 5.4 3.00012H16.6C17.7314 3.00012 18.2971 3.00012 18.6485 3.35159C19 3.70307 19 4.26875 19 5.40012V16.6001C19 17.7315 19 18.2972 18.6485 18.6487C18.2971 19.0001 17.7314 19.0001 16.6 19.0001H5.4C4.26863 19.0001 3.70294 19.0001 3.35147 18.6487C3 18.2972 3 17.7315 3 16.6001V5.40012Z" fill="currentColor"/>
<path d="M5.85215 11.0001C5.85215 10.4478 6.29987 10.0001 6.85215 10.0001H15.1479C15.7001 10.0001 16.1479 10.4478 16.1479 11.0001C16.1479 11.5524 15.7001 12.0001 15.1479 12.0001H6.85215C6.29986 12.0001 5.85215 11.5524 5.85215 11.0001Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_2233_44787">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>
